export default "__VITE_ASSET__fAsbdhcE__"